import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { createCustomElement } from '@angular/elements';

import { AppModule } from './app/app.module';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { WidgetConfig } from './app/web-component-config';
import { setWidgetConfig } from './app/widget-config-store';

if (environment.production) {
  enableProdMode();
}

if (!environment.isWebComponent) {
  // SPA: bootstrap directo
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
} else {
  // Web Component: expone initBelenderComponent(config) para que el host
  // pase la config (runtimeEnv, organization, notificationsUrl, scraperMock, etc.) ANTES de bootstrapar el módulo.
  (window as any).initBelenderComponent = async (config?: WidgetConfig) => {
    if ((window as any).BelenderWebComponent) {
      return (window as any).BelenderWebComponent;
    }

    setWidgetConfig(config ?? {});
    const moduleRef = await platformBrowserDynamic().bootstrapModule(AppModule);
    const el = createCustomElement(AppComponent, { injector: moduleRef.injector });
    (window as any).BelenderWebComponent = el;
    return el;
  };
}
